import { useEffect, useState } from 'react';
import { ChannelLayout } from 'core/models/channel';
import { useLatencyMeasure, useLatencyMeasurePoints, useUpdateLatencyMeasures } from 'services/latency/useLatencyMeasure';

export function useAutomaticLatencyMeasurement(layout: ChannelLayout | undefined) {
    const latencyMeasures = useLatencyMeasure(layout);

    const { points, addPoint, clearPoints } = useLatencyMeasurePoints(latencyMeasures);

    const [intervalMS, setIntervalMS] = useState(-1);
    useUpdateLatencyMeasures(latencyMeasures, intervalMS);

    useEffect(() => {
        if (intervalMS <= 0) return;

        const interval = setInterval(() => {
            addPoint();
        }, intervalMS);
        return () => clearInterval(interval);
    }, [addPoint, intervalMS]);

    return {
        points,
        start: (intervalMS: number) => setIntervalMS(intervalMS),
        stop: () => setIntervalMS(-1),
        reset: () => clearPoints()
    };
}
